"use client"

export { RibbonMenu } from "@/components/editor/ribbon/ribbon-menu"
